export const download = () => (
  <svg
    width="27"
    height="28"
    viewBox="0 0 27 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.2293 18.6667L7.88579 12.8333L9.38198 11.1417L12.1606 14.175V4.66667H14.298V14.175L17.0766 11.1417L18.5728 12.8333L13.2293 18.6667ZM6.81709 23.3333C6.22931 23.3333 5.72613 23.1049 5.30755 22.6479C4.88897 22.191 4.67969 21.6417 4.67969 21V17.5H6.81709V21H19.6415V17.5H21.7789V21C21.7789 21.6417 21.5696 22.191 21.1511 22.6479C20.7325 23.1049 20.2293 23.3333 19.6415 23.3333H6.81709Z"
      fill="white"
    />
  </svg>
);
